export const HOUSE_LOGO_URL = "https://uploads.orevital.com/postcue/ov-logo.png";

// The ov-logo.png asset (1448×1086) carries ~28% transparent padding above and
// ~26% below the artwork. The wrapper is sized to the artwork's bounding box and
// the image is shifted up so only empty padding is hidden — the logo itself is
// never scaled, distorted or cropped. Widths: 130 mobile / 150 tablet / 180 desktop.
export function BrandLogo({ alt = "OreVital", className = "" }) {
  return (
    <span
      className={`block shrink-0 overflow-hidden w-[130px] md:w-[150px] lg:w-[180px] ${className}`}
      style={{ aspectRatio: "1448 / 502" }}
      data-testid="brand-logo"
    >
      <img
        src={HOUSE_LOGO_URL}
        alt={alt}
        className="block w-full h-auto max-w-none"
        style={{ marginTop: "-21.06%" }}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    </span>
  );
}
